import { Helmet } from 'react-helmet-async';

export const QualityPolicy = () => {
    return (
    <>
        <Helmet>
            <title>Polityka Jakości | Biuro rachunkowe Saldo.pl | Cieszyn</title>
            <meta name="description" content="Nasza polityka jakości opiera się na profesjonalizmie, bezpieczeństwie danych i indywidualnym podejściu do każdego klienta. Poznaj standardy pracy biura rachunkowego Saldo.pl." />
            <meta name="keywords" content="polityka jakości biuro rachunkowe, standardy księgowe, bezpieczeństwo danych księgowych, profesjonalizm księgowy, polityka biura rachunkowego" />
            <link rel="canonical" href="https://podatki-saldo.pl/qualitpolicy" />
            <meta property="og:title" content="Polityka Jakości | Standardy pracy biura rachunkowego Saldo.pl" />
            <meta property="og:description" content="Dowiedz się, jakie standardy jakości stosujemy w naszej pracy. Profesjonalizm, bezpieczeństwo i indywidualne podejście to nasze priorytety." />
            <meta property="og:url" content="https://podatki-saldo.pl/qualitpolicy" />
            <meta property="og:type" content="website" />
        </Helmet>
        <div className="main-content">
            QualityPolicy
        </div>
    </>
    )
}